import { Utils, ObjectHelper } from '../../../../helpers'
import { IEntityMappingConfig, EntityMapping } from './'

export class EntityMappingFactory {
  public constructor(
    private _utils: Utils,
    private _objectHelper: ObjectHelper
  ) {}

  public get(entityMappingConfig: IEntityMappingConfig) {
    const entityMapping = new EntityMapping(entityMappingConfig.classType, entityMappingConfig.jsonType, this._utils, this._objectHelper)
    entityMapping.setCustomMapping(entityMappingConfig.propertyMapping)
    return entityMapping
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/entity-mapping-manager/entity-mapping/entity-mapping.factory.ts